
















































import { Vue, Component, Model } from "vue-property-decorator";
import { debounce } from 'typescript-debounce-decorator';
import PersonDTO from "@/dto/person/PersonDTO";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import AdminService from "@/services/AdminService";
import SublimeEmployeeFilterDTO from "@/dto/sublime/employee/SublimeEmployeeFilterDTO";
import { processError } from "@/utils/ComponentUtils";
import CommonInputMixin from "@/components/new_style_components/mixins/CommonInputMixin.vue";

@Component({
  inheritAttrs: false,
  mixins: [CommonInputMixin],
})
export default class SublimeSearch extends Vue {
  @Model('change', {default: null})
  private selectedSublime!: SublimeEmployeeDTO | PersonDTO | null;

  private filter = new SublimeEmployeeFilterDTO({pageSize: 8});

  private sublimeEmployeeDTOS: Array<SublimeEmployeeDTO> = [];

  private showList = false;

  mounted(): void {
    if (this.selectedSublime) {
      this.filter.fullNameFilter = this.selectedSublime.firstName + ' ' + this.selectedSublime.lastName;
    }
  }

  @debounce(500)
  search(): void {
    if (!this.filter.fullNameFilter) {
      this.$emit('change', {id: null});
    }
    AdminService.getEmployees(this.filter).then(
        ok => {
          this.sublimeEmployeeDTOS = ok.data.data;
          this.showList = true;
        },
        err => {
          processError(err, this);
        }
    )
  }

  selectSublime(s: SublimeEmployeeDTO): void {
    this.showList = false;
    this.filter.fullNameFilter = s.firstName + ' ' + s.lastName;
    this.$emit('change', s);
  }
}
